import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("../views/Maintenance.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Aluno (a)", "Administrador (a)", "Supervisor (a)"],
    },
  },
  {
    path: "/validation",
    name: "Validation",
    component: () => import("../views/Validation.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Administrador (a)", "Supervisor (a)"],
    },
  },
  {
    path: "/validation/:id",
    name: "EvaluateEnrolled",
    component: () => import("../views/EvaluateEnrolled.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Administrador (a)", "Supervisor (a)"],
    },
  },
  {
    path: "/form",
    name: "EnrollForm",
    component: () => import("../views/EnrollForm.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Aluno (a)", "Administrador (a)", "Supervisor (a)"],
    },
  },

  {
    path: "/profile/:id",
    name: "Profile",
    component: () => import("../views/Profile.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Administrador (a)"],
    },
  },
  // {
  //   path: "/offers",
  //   name: "Offers",
  //   component: () => import("../views/Offers.vue"),
  //   meta: {
  //     authRequired: true,
  //     grantAll: false,
  //     grants: ["Administrador (a)"],
  //   },
  // },
  {
    path: "/offers/create",
    name: "CreateOffer",
    component: () => import("../views/CreateOrEditOffer.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Administrador (a)"],
    },
  },
  // {
  //   path: "/offers/edit/:id",
  //   name: "EditOffer",
  //   component: () => import("../views/CreateOrEditOffer.vue"),
  //   meta: {
  //     authRequired: true,
  //     grantAll: false,
  //     grants: ["Administrador (a)"],
  //   },
  // },
  {
    path: "/record",
    name: "Record",
    component: () => import("../views/Record.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Administrador (a)", "Supervisor (a)"],
    },
  },
  {
    path: "/license",
    name: "License",
    component: () => import("../views/License.vue"),
    meta: {
      authRequired: true,
      grantAll: false,
      grants: ["Administrador (a)", "Supervisor (a)"],
    },
  },
  // Redirecionamento para / ao tentar acessar rota inexistente
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  const authRequired = to.meta.authRequired;
  const loggedIn = JSON.parse(localStorage.getItem("user"));
  const inMaintenance = localStorage.getItem("maintenance");
  const currentPath = to.path;

  // Bloqueando acesso às outras rotas caso o site esteja em manutenção
  if (inMaintenance === "true" && currentPath !== "/maintenance") {
    next("/maintenance");
  }

  // Verifica se precisa de login ou não
  if (authRequired && !loggedIn) {
    // Caso não esteja logado, redireciona para a página de login
    next("/login");
  } else if (authRequired && loggedIn) {
    // Caso esteja logado, verifica se tem permissão para acessar a página
    const authToken = loggedIn.token;
    const userRoles = loggedIn.roles;
    const grants = to.meta.grants;
    let permission = false;

    // Verifica os papéis do usuário
    for (let role of userRoles) {
      for (let grant of grants) {
        if (role.nome === grant) {
          permission = true;
          break;
        }
      }
      if (permission) break;
    }

    if ((authToken && to.meta.grantAll) || (authToken && permission)) {
      // Permissão concedida
      next();
    } else {
      // Permissão negada
      next("/");
    }
  } else {
    next();
  }
});

export default router;
